import { render, staticRenderFns } from "./m_tech035.vue?vue&type=template&id=432f79e7&scoped=true&"
import script from "./m_tech035.vue?vue&type=script&lang=js&"
export * from "./m_tech035.vue?vue&type=script&lang=js&"
import style0 from "./m_tech035.vue?vue&type=style&index=0&id=432f79e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f79e7",
  null
  
)

export default component.exports